/* this might become a server component in the future. It depends on OverlayCircle */
'use client';

import { SoftHyphenInjector } from '../SoftHyphenInjector';
import type { OverlayCircleType } from './types';
import { classes } from '../../utils/classes';

/**
 * This component shows editorial content of a teaser.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const OverlayCircleItem = ({ data }: { data: OverlayCircleType }) => {
  const {
    field_text_01: text01,
    field_text_02: text02,
    field_text_03: text03,
    behavior_paragraph_invert_font_color: styleIsNegativeTextColor = false,
  } = data;

  return (
    <span
      className={classes(
        'flex w-full flex-col items-center justify-evenly text-[0.75rem] leading-[0.875rem] @min-[900px]:text-[1.25rem] @min-[900px]:leading-[1.688rem]',
        styleIsNegativeTextColor ? 'text-color-text-dark' : 'text-color-text-light',
      )}
    >
      {text01 && <SoftHyphenInjector text={text01} />}
      {text02 && (
        <SoftHyphenInjector
          text={text02}
          className="w-max text-[2.563rem] leading-[2.563rem] @min-[900px]:text-[5.313rem] @min-[900px]:leading-[5.75rem]"
        />
      )}
      {text03 && <SoftHyphenInjector text={text03} />}
    </span>
  );
};
